import React from "react";
import { buildRow } from "../../util/FormatUtil";
import { isEmptyObject } from "jquery";

interface OrderHistoryModalState {
  selectedOrder: any;
}

interface OrderHistoryModalProps {
  selectedOrder: any;
  facilities?: any[];
  products?: any[];
}

export default class OrderHistoryModal extends React.Component<OrderHistoryModalProps, OrderHistoryModalState> {
  public static ID = "orderhistory";

  constructor(props) {
    super(props);
    this.state = {
      selectedOrder: null,
    };
  }

  componentDidMount(): void {
    $(`#${OrderHistoryModal.ID}`).on("shown.bs.modal", function () {
      $(document).off("focusin.modal");
    });
  }

  componentWillReceiveProps(nextProps: Readonly<OrderHistoryModalProps>) {
    if (!isEmptyObject(nextProps.selectedOrder)) {
      this.setState({ selectedOrder: nextProps.selectedOrder });
    }
  }

  formatDate(dateString: string) {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  getFacilityName(facilityID: number) {
    if (!this.props.facilities || !facilityID) return "";
    const facility = this.props.facilities.find((f) => f.ID === facilityID);
    return facility ? facility.FacilityName : "";
  }

  getProductNames() {
    const order = this.state.selectedOrder;
    if (!order?.ProductMap || !this.props.products) return "";
    try {
      const productMap = typeof order.ProductMap === "string" ? JSON.parse(order.ProductMap) : order.ProductMap;
      return productMap
        .map((item) => {
          const product = this.props.products.find((p) => p.ID === item.ProductID);
          return product ? `${product.Name} (x${item.Quantity})` : `Product #${item.ProductID} (x${item.Quantity})`;
        })
        .join(", ");
    } catch {
      return "";
    }
  }

  render() {
    const order = this.state.selectedOrder;
    // console.log('OrderHistoryModal', order)

    return (
      <div
        className="modal fade form_modal"
        id={OrderHistoryModal.ID}
        tabIndex={-1}
        role="dialog"
        aria-labelledby="result_modal_label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title" id="result_modal_label">
                  Order Details
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {/* Order Section */}
                <div className="mb-4">
                  <h5 className="text-center border-bottom pb-2 mb-3">Order Information</h5>
                  {buildRow(
                    "Order #",
                    <input
                      className="form-control"
                      readOnly
                      value={order?.ReqNum || ""}
                    />
                  )}
                  {buildRow(
                    "Order Date",
                    <input
                      className="form-control"
                      readOnly
                      value={this.formatDate(order?.CreatedDate)}
                    />
                  )}
                  {buildRow(
                    "Facility",
                    <input
                      className="form-control"
                      readOnly
                      value={this.getFacilityName(order?.FacilityID)}
                    />
                  )}
                  {buildRow(
                    "Product",
                    <input
                      className="form-control"
                      readOnly
                      value={this.getProductNames()}
                    />
                  )}
                  {buildRow(
                    "Tracking #",
                    <input
                      className="form-control"
                      readOnly
                      value={order?.TrackingNumber || ""}
                    />
                  )}
                  {buildRow(
                    "Status",
                    <input
                      className="form-control"
                      readOnly
                      value={order?.TrackingStatus || ""}
                    />
                  )}                  
                </div>

                {/* Recipient Information Section */}
                {order?.DSPatientFirstName && (
                  <div className="mt-4">
                    <h5 className="text-center border-bottom pb-2 mb-3">Recipient Information</h5>
                    {buildRow(
                      "First Name",
                      <input
                        className="form-control"
                        readOnly
                        value={order?.DSPatientFirstName || ""}
                      />
                    )}
                    {buildRow(
                      "Last Name",
                      <input
                        className="form-control"
                        readOnly
                        value={order?.DSPatientLastName || ""}
                      />
                    )}
                    {buildRow(
                      "Address",
                      <input
                        className="form-control"
                        readOnly
                        value={order?.DSPatientAddress || ""}
                      />
                    )}
                    {buildRow(
                      "Phone Number",
                      <input
                        className="form-control"
                        readOnly
                        value={order?.DSPatientPhoneNumber || ""}
                      />
                    )}
                    {buildRow(
                      "Email",
                      <input
                        className="form-control"
                        readOnly
                        value={order?.DSPatientEmail || ""}
                      />
                    )}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
